import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './ContactInfoSection.scss';

const ContactInfoSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    return (
        <section className="contact-info-section">
            <div className="contact-info-section__container">
                <div className="contact-info-section__grid">

                    <div className="contact-info-section__text-col">
                        <motion.div className="contact-info-section__header" {...fadeUp(0, 1.1)}>
                            <h2 className="contact-info-section__title">{t('contact_information')}</h2>
                            <div className="contact-info-section__divider"></div>
                        </motion.div>
                        <motion.p className="contact-info-section__description" {...fadeUp(0.15)}>
                            {t('contact_description')}
                        </motion.p>

                        <motion.div className="contact-info-section__blocks" {...fadeUp(0.3)}>
                            <div className="contact-info-section__block">
                                <h3 className="contact-info-section__subtitle">{t('address')}</h3>
                                <p className="contact-info-section__text">
                                    {t('church_address')}
                                </p>
                            </div>

                            <div className="contact-info-section__block">
                                <h3 className="contact-info-section__subtitle">{t('service_times')}</h3>
                                <p className="contact-info-section__text">
                                    {t('contact_service_times_detail')}
                                </p>
                            </div>

                            <div className="contact-info-section__block">
                                <h3 className="contact-info-section__subtitle">{t('text_us')}</h3>
                                <a href="tel:+12159678777" className="contact-info-section__phone">
                                    (215) 967-8777
                                </a>
                            </div>
                        </motion.div>
                    </div>

                    <motion.div className="contact-info-section__map-col" {...fadeUp(0.2)}>
                        <div className="contact-info-section__map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.4239!2d-74.852!3d40.178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c151261b198351%3A0xa313c99eac9a59ee!2s920%20Trenton%20Rd%2C%20Fairless%20Hills%2C%20PA%2019030!5e0!3m2!1sen!2sus!4v1234567890"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                title={t('map_title')}
                                className="contact-info-section__map"
                            />
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default ContactInfoSection;
